import JSEncrypt from 'jsencrypt';
import cryptoJs from 'crypto-js';

const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtANTHxdRrmg+pSJSO8gYkbROiujn6MNE/0SlS/LQfT0yNCPVJHgMlqOcbZ79U7CH0Fz4nM8UZUqmMelcMc+7rJ97Z6FJhyWW5iJHEPZN7RVPeTP9GT9fsSE1svTrNiBaz7rmvrEJ5vCr5icjYbV2A6yh44+sbb6bVre3kAPUWax7dxAqcGtyFnyvMEG/Xk+k/IhCh6VDjfyFw/yQennQntfYTlXuZMgZQzTNpN+TcSlynPT5k7U6oxFcCJSELou59s6LdxtCx+1iqaPXLZvScRCPD6l54ut5xiCmUlmOEBXzMEww1fwQbLwHiIyXyt/JKJ1TbemLjIpd739ZJRdibwIDAQAB';
// RSA加密
export function encrypt(data) {
  var encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);// 设置公钥
  return encryptor.encrypt(data); // 对需要加密的数据进行加密
}

// RSA解密
export function decrypt(data) {
  var encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);
  return encryptor.decrypt(data);
}
// DES加密
export const encryptDes = (message, key) => {

  var keyHex = cryptoJs.enc.Utf8.parse(key)
  var option = { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 }
  var encrypted = cryptoJs.DES.encrypt(JSON.stringify(message), keyHex, option)
  return encrypted.ciphertext.toString(); // 返回hex格式密文，如需返回base64格式：encrypted.toString()
}
// DES解密
export const decryptDes = (message, key) => {
  var keyHex = cryptoJs.enc.Utf8.parse(key);
  var decrypted = cryptoJs.DES.decrypt({ ciphertext: cryptoJs.enc.Hex.parse(message) }, keyHex, { mode: cryptoJs.mode.ECB, padding: cryptoJs.pad.Pkcs7 });
  return decrypted.toString(cryptoJs.enc.Utf8);
}
// 随机生成指定数量的16进制key
export const generatekey = (num) => {
  const library = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let key = '';
  for (var i = 0; i < num; i++) {
    const randomPoz = Math.floor(Math.random() * library.length);
    key += library.substring(randomPoz, randomPoz + 1);
  }
  return key;
}
